import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalOptions } from '../../kz-ui/ui/modal/modal-options';
import { SeoService } from 'src/app/shared/services/utilities/seo.service';
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs/operators";
import { RoutesService } from "../../shared/services/routes/routes.service";
import { Observable } from "rxjs";

@Component({
  selector: 'app-modal-view',
  template: `<kz-modal *ngIf="modalOptions$ | async as modalOptions" [options]="modalOptions"><router-outlet></router-outlet></kz-modal>`,
  styleUrls:  ['./auth.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthComponent implements OnInit {

  public modalOptions$: Observable<ModalOptions>;

  constructor(
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private routeService: RoutesService,
  ) {
    this.seoService.initFollow(
      'noindex, nofollow'
    );
  }

  ngOnInit() {
    this.modalOptions$ = this.routeService.eventNavigationEnd.pipe(
      map((data) =>  ({
          size: this.activatedRoute.snapshot.data?.modalSize || 'register',
          backdrop: true,
          closeButton: false,
          contentBackground: false,
          windowClasses: 'kz-registerV2-bg',
        })
      )
    );
  }

  ngOnDestroy(): void {
    this.seoService.initFollow('index, follow');
  }
}
